<template>
  <div v-if="isLoading">
    <div class="text-center text-danger screen-center">
      <div class="align-middle spinner-bubble spinner-bubble-danger mr-5"></div>
      <strong>Cargando...</strong>
    </div>
  </div>
  <div v-else>
    <div class="row">
      <div class="col-sm-5">
        <div class="breadcrumb">
          <h1>Modificar Categoria
            <span class="h4 pl-2">
              N°: {{ numero }}
            </span>
          </h1>
        </div>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-sm-12 mb-4">
        <div class="card text-left">
          <div class="card-header">
            <div class="col-sm-5">
              <button class="btn th-custom-color text-dark mr-2"
              type="button"
              @click="updateCategoria"
              :disabled="disabledButton">
              Guardar
              </button>
              <button class="btn th-custom-color text-dark"
              type="button"
              @click="componentShow = 'TheIndexCategoriaLinae'">
              Regresar
              </button>
            </div>
          </div>
          <div class="card-body">
            <div class="form-group row">
              <label for="codigo_categoria"
              class="col-sm-2 col-form-label text-right">
              Codigo Categoria:
              <span
                  class="text-danger">*
              </span>
              </label>
              <div class="col-sm-2">
                <input type="text" class="form-control"
                v-model="codigoCategoria"
                placeholder="Ingrese el codigo" required>
              </div>
              <label for="descripcion_categoria"
              class="col-sm-2 col-form-label text-right">
                Nombre Categoria:
                <span
                  class="text-danger">*
                </span>
              </label>
              <div class="col-sm-3">
                <input type="text" class="form-control"
                v-model="nombreCategoria"
                placeholder="Ingrese el nombre de la categoria" required>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-sm-12">
                <h4>SubCategoria</h4>
              </div>
            </div>
            <div class="form-group row">
              <label for="nombre_sub_categoria"
              class="col-sm-2 col-form-label text-right">
              Codigo Sub Categoria:
              <span
                class="text-danger">*
              </span>
              </label>
              <div class="col-sm-2">
                <input type="text" class="form-control"
                v-model="codigoSubCategoria"
                placeholder="Ingrese el codigo" required>
              </div>
              <label for="descripcion_sub_categoria"
              class="col-sm-2 col-form-label text-right">
                Nombre Sub Categoria:
                <span
                  class="text-danger">*
                </span>
              </label>
              <div class="col-sm-3">
                <input type="text" class="form-control"
                v-model="nombreSubCategoria"
                placeholder="Ingrese el nombre de la sub categoria" required>
              </div>
              <div class="col-sm-3">
                <button class="btn th-custom-color text-dark"
                type="button"
                @click="addSubCategoria()"
                >Agregar</button>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div style="display: flex; width: 100%; text-align:center">
                  <table class="table table-bordered table-hover" width="100%">
                    <thead>
                      <tr>
                        <th width="3%"></th>
                        <th width="3%"></th>
                        <th width="10%" class="text-center">ID</th>
                        <th width="20%" class="text-center">Codigo</th>
                        <th width="45%">Nombre</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(subCategoria, index) in listaSubCategoriasFiltereds"
                      :key="index">
                        <td class="text-center">
                          <i class="nav-icon i-Pen-5 font-weight-bold text-success"
                          style="cursor: pointer"
                          @click="edit(index)"
                          ></i>
                        </td>
                        <td class="text-center">
                          <a class="delete text-danger"
                          @click="eliminar(subCategoria)">
                            <i class="nav-icon i-Close-Window font-weight-bold"
                            style="cursor: pointer"></i>
                          </a>
                        </td>
                        <td v-if="subCategoria.id === 0"> S/N </td>
                        <td v-else> {{ subCategoria.numero_interno }} </td>
                        <td>
                          <input type="text"
                          v-model="subCategoria.codigo"
                          :readonly="readInputs[index].value"
                          class="form-control">
                        </td>
                        <td>
                          <input type="text" v-model="subCategoria.nombre"
                          :readonly="readInputs[index].value"
                          class="form-control">
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { util } from '@/plugins/util';
import { mapFields } from 'vuex-map-fields';
import { mapActions } from 'vuex';

export default {
  name: 'TheEditClasificacionCie',
  data() {
    return {
      disabledButton: false,
    };
  },
  methods: {
    addSubCategoria() {
      if (this.validarAddSubClasificacion()) {
        this.listaSubCategorias.push({
          id: 0,
          numero: this.readInputs.length + 1,
          nombre: this.nombreSubCategoria,
          codigo: this.codigoSubCategoria,
          estado: true,
          key: `C-${new Date().getTime()}`,
        });
        this.readInputs.push({ value: true });
        this.limpiarDataSubClasificacion();
      }
    },
    limpiarDataSubClasificacion() {
      this.codigoSubCategoria = null;
      this.nombreSubCategoria = null;
    },
    validarAddSubClasificacion() {
      let valido = true;
      if (!this.nombreSubCategoria) {
        valido = false;
        util.showNotify('El nombre de la sub categoria es requerido', 'warn');
      }
      if (!this.codigoSubCategoria) {
        valido = false;
        util.showNotify('El codigo de la sub categoria es requerido', 'warn');
      }
      const codigo = this.listaSubCategorias.find((el) => (
        el.codigo === this.codigoSubCategoria && el.estado === true));
      if (codigo) {
        valido = false;
        util.showNotify('El codigo de la sub categoria ya existe en el detalle', 'warn');
      }
      return valido;
    },
    validar() {
      let valido = true;
      if (!this.codigoCategoria) {
        valido = false;
        util.showNotify('El codigo de la categoria es requerido', 'warn');
      }
      if (!this.nombreCategoria) {
        valido = false;
        util.showNotify('El nombre de la categoria es requerido', 'warn');
      }
      if (this.listaSubCategorias.length === 0) {
        valido = false;
        util.showNotify('Debe agregar al menos una sub categoria', 'warn');
      }
      return valido;
    },
    eliminar(item) {
      const INDEX = this.listaSubCategorias.findIndex((el) => el.key === item.key);
      if (item.id === 0) {
        this.listaSubCategorias.splice(INDEX, 1);
      } else {
        // cambiar el estado a false
        this.listaSubCategorias[INDEX].estado = false;
      }
      this.readInputs.splice(INDEX, 1);
    },
    edit(row) {
      this.readInputs[row].value = false;
    },
    ...mapActions('formularioCategoriaLinae', [
      'resetFoumularioCategoriStore',
    ]),
    ...mapActions('categoriaLinaeApis', [
      'callUpdateApi',
      'callIndexApi',
    ]),
    async updateCategoria() {
      this.disabledButton = true;
      const UPDATE_OK = await this.callUpdateApi(this.itemId);
      if (UPDATE_OK) {
        this.callIndexApi();
      }
      this.disabledButton = false;
    },
  },
  beforeDestroy() {
    this.resetFoumularioCategoriStore();
  },
  computed: {
    ...mapFields('formularioCategoriaLinae', [
      'componentShow',
      'nombreCategoria',
      'codigoCategoria',
      'listaSubCategorias',
      'codigoSubCategoria',
      'nombreSubCategoria',
      'readInputs',
      'isLoading',
      'numero',
      'itemId',
    ]),
    listaSubCategoriasFiltereds() {
      return this.listaSubCategorias.filter((item) => item.estado === true);
    },
  },
  watch: {},
};
</script>
